import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useMemo, useRef, useCallback } from "react";
import {
    setTheEMployeeAttendanceProfileActions,
    setTheEMployeeAttendanceupdateProfileActions,
    setTheudsEmployeeImage
} from "../../../Redux/Slice";
import Webcam from "react-webcam";
import Modal from "react-modal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../../StyleSheet/MainComponent/Userprofile.scss";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import sing from "../../../Assets/signature-required-2C3A7TG.jpg";
import axios from "axios";
import { PresentUrl } from "../../../text/apidata";
import { store } from "../../../Redux/Store";
import ImageCropper from "../ReactcropOverall/Imagecrop";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import LaptopIcon from '@mui/icons-material/Laptop';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import EditIcon from '@mui/icons-material/Edit';
const UdsEmpProfile = () => {
    const dispatch = useDispatch();
    const state = useSelector((state) => state);
    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive
    );

    const UserObjectData = useSelector((state) => state.users.UserData);
    const createnewuser = {
        first_name: "",
        email: "",
        phone_number: "",
        last_name: "",
    };
    const fileInputRef = useRef()
    const [data, setData] = useState(createnewuser);
    const [UserID, setUserID] = useState("");
    const [ManagerSign, SetManagerSign] = useState(false);
    const [Img, setImg] = useState(null);
    const [img, setimg] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [CroppImageView, setCroppImageView] = useState(false);
    const [UserFile, setUserFile] = useState()
    const firstLetter = data.first_name ? data.first_name.charAt(0) : "";
    console.log(firstLetter, "firstLetter");

    const [FILE, setImgFile] = useState(null);
    const [FileTrue, setFileTrue] = useState(false);
    const Signature = {
        signature: "",
    };
    const [Signs, setSign] = useState(Signature);
    const form_data = new FormData();
    const [showWebcam, setShowWebcam] = useState(false);
    const webcamRef = useRef(null);
    const [signed, setsigned] = useState(false);
    const [RegionMap, setRegionMap] = useState([]);
    const [userdata, setuserdata] = useState({
        state: "",
        region: "",
        zone: "",
    });
    const [Roles, setRoles] = useState("");
    ///---present---url
    const [PresentUrls, setPresentUrls] = useState([]);
    const [presenturlInUrl, seturlandfile] = useState({
        file: "",
        url: ""
    })
    const [profilePopup, setProfilePoup] = useState(false)
    const [profilePopupUploads, setProfilePoupuploads] = useState(false)
    const [profilePopupUploadsNumber, setProfilePoupuploadsnumber] = useState(1)





    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
        const maxSize = 3 * 1024 * 1024; // 3MB in bytes

        if (file && allowedTypes.includes(file.type)) {
            if (file.size > maxSize) {
                toast.error("File size exceeds 3MB. Please upload a smaller image.");
            } else {
                const reader = new FileReader();
                reader.onload = (e) => { };
                reader.readAsDataURL(file);
                setImgFile(file);
                setUserFile(event)
                setFileTrue(true);
                setCroppImageView(true)
            }
        } else {
            toast.error("Please upload an image file (jpg, jpeg, png, svg).");
        }
    };

    const updateAvatar = (imgSrc) => {
        fileInputRef.current = imgSrc;
    };
    const handleCameraClick = () => {
        setIsModalOpen(true);
    };

    const capturePhoto = useCallback(() => {
        setPresentUrls([]);
        const imageSrc = webcamRef.current.getScreenshot();
        setimg(imageSrc);
        const file = dataURLtoFile(imageSrc, "webcam_photo.jpg");
        setImgFile(file);

        const generateRandomNumber = () => {
            return Math.floor(Math.random() * 100000);
        };
        const createPresentData = (file) => {
            const randomNumber = generateRandomNumber();
            const formattedFilename = `onboarding/user_image/user_image${randomNumber}.${file.type.split('/')[1]}`; // Use the file's extension
            const Presentdata = {
                multiple_files: [
                    {
                        filename: formattedFilename,
                        file_type: file.type,
                    },
                ],
            };

            return Presentdata;
        };



        const Presentdata = createPresentData(file);

        axios({
            url: PresentUrl,
            method: 'post',
            data: Presentdata,
            headers: {
                Authorization:
                    "Bearer " +
                    store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
            },
        })
            .then((response) => {
                const uploadedFiles = response.data.data;
                const newUrls = uploadedFiles.map(urls => ({
                    url: urls,
                    type: file.type,
                    putfiles: file

                }));

                try {
                    const response = fetch(newUrls[0].url, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': file.type,
                            "x-amz-acl": "public-read"
                        },
                        body: file,
                    });


                    const payload = {
                        form_data: {
                            // sign: state.signaturepad.PresentURL,
                            user_image: String(newUrls[0].url).split("?")[0]
                        },
                        id: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
                            .id,
                    };
                     dispatch(setTheudsEmployeeImage(String(newUrls[0].url).split("?")[0]))
                    dispatch(setTheEMployeeAttendanceupdateProfileActions(payload));
                    setProfilePoupuploads(false); setProfilePoup(false);
                    setProfilePoupuploadsnumber(1)

                } catch (error) {
                    console.error('Error uploading files:', error);
                }
                setPresentUrls(prevUrls => [...prevUrls, ...newUrls]);
                seturlandfile({
                    url: String(response.data.data).split("?")[0]
                })
            }).catch((error) => {
                console.error('Error uploading files:', error);
            });



        setIsModalOpen(false);
        setFileTrue(true);
    }, [webcamRef]);

    const closeModal = () => {
        setIsModalOpen(false);
    };

    ////---___Signature-----Popup---------------------
    const [SignaturePopups, setSignaturePopup] = useState(false);

    useEffect(() => {
        dispatch(setTheEMployeeAttendanceProfileActions());
    }, [state.EmployeeProfilepostUpdateListData.UpdatePostUrlEmpAttendaProfile]);
    useEffect(() => {
        if (
            state.EmployeeProfileGetListData.EmployeeProfileGetDataList != undefined) {
            setData({
                ...data,
                first_name: state.EmployeeProfileGetListData.EmployeeProfileGetDataList.first_name,
                last_name: state.EmployeeProfileGetListData.EmployeeProfileGetDataList.last_name,
                email: state.EmployeeProfileGetListData.EmployeeProfileGetDataList.email,
                phone_number:
                    state.EmployeeProfileGetListData.EmployeeProfileGetDataList.phone_number != null
                        ? state.EmployeeProfileGetListData.EmployeeProfileGetDataList.phone_number
                        : "",
            });
            if (state.EmployeeProfileGetListData.EmployeeProfileGetDataList.user_role != null &&
                state.EmployeeProfileGetListData.EmployeeProfileGetDataList.user_role != undefined
                &&
                state.EmployeeProfileGetListData.EmployeeProfileGetDataList.user_role != ""
            ) {
                setRoles(state.EmployeeProfileGetListData.EmployeeProfileGetDataList.user_role.role);
            }
            if (
                state.EmployeeProfileGetListData.EmployeeProfileGetDataList.user_image != undefined &&
                state.EmployeeProfileGetListData.EmployeeProfileGetDataList.user_image != null &&
                state.EmployeeProfileGetListData.EmployeeProfileGetDataList.user_image.media_url != undefined
            ) {
                seturlandfile({
                    ...presenturlInUrl,
                    ur: state.EmployeeProfileGetListData.EmployeeProfileGetDataList.user_image.media_url
                })
                setimg(state.EmployeeProfileGetListData.EmployeeProfileGetDataList.user_image.media_url);
            }
        }
    }, [state.EmployeeProfileGetListData.EmployeeProfileGetDataList, state.EmployeeProfilepostUpdateListData.UpdatePostUrlEmpAttendaProfile,
        profilePopupUploads]);

    // console.log(state.EmployeeProfileGetListData.EmployeeProfileGetDataList,
    //     state.EmployeeProfileGetListData.EmployeeProfileGetDataList.first_name
    //     , "EmployeeProfileGetListData");


    function getCroppedImg(imageRef, crop, fileName) {
        setPresentUrls([])
        const canvas = document.createElement("canvas");
        const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
        const scaleY = imageRef.current.naturalHeight / imageRef.current.height;
        canvas.width = crop.width * scaleX;
        canvas.height = crop.height * scaleY;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(
            imageRef.current,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width * scaleX,
            crop.height * scaleY
        );



        return new Promise((resolve, reject) => {
            canvas.toBlob((blob) => {
                if (!blob) {
                    console.error("Canvas is empty");
                    return;
                }
                const croppedFile = new File([blob], fileName, {
                    type: "image/jpeg",
                });
                var file = croppedFile;
                if (croppedFile) {
                    setTimeout(() => {
                        setCroppImageView(false)

                    }, 0);



                    const generateRandomNumber = () => {
                        return Math.floor(Math.random() * 100000);
                    };

                    const createPresentData = (croppedFile) => {
                        const randomNumber = generateRandomNumber();
                        const formattedFilename = `onboarding/user_image/user_image${randomNumber}.${croppedFile.type.split('/')[1]}`; // Use the file's extension
                        const Presentdata = {
                            multiple_files: [
                                {
                                    filename: formattedFilename,
                                    file_type: croppedFile.type,
                                },
                            ],
                        };

                        return Presentdata;
                    };



                    const Presentdata = createPresentData(croppedFile);

                    axios({
                        url: PresentUrl,
                        method: 'post',
                        data: Presentdata,
                        headers: {
                            Authorization:
                                "Bearer " +
                                store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
                        },
                    })
                        .then((response) => {
                            console.log('Files uploaded successfully:', response.data);
                            const uploadedFiles = response.data.data;
                            const newUrls = uploadedFiles.map(file => ({
                                url: file,
                                type: croppedFile.type,
                                putfiles: croppedFile

                            }));
                            console.log(newUrls, "newUrls", newUrls[0]);

                            try {
                                const response = fetch(newUrls[0].url, {
                                    method: 'PUT',
                                    headers: {
                                        'Content-Type': croppedFile.type,
                                        "x-amz-acl": "public-read"
                                    },
                                    body: croppedFile,
                                });


                                const payload = {
                                    form_data: {
                                        // sign: state.signaturepad.PresentURL,
                                        user_image: String(newUrls[0].url).split("?")[0]
                                    },
                                    id: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
                                        .id,
                                };
                                dispatch(setTheudsEmployeeImage(String(newUrls[0].url).split("?")[0]))

                                dispatch(setTheEMployeeAttendanceupdateProfileActions(payload));
                                setProfilePoupuploads(false); setProfilePoup(false);
                                setProfilePoupuploadsnumber(1)

                            } catch (error) {
                                console.error('Error uploading files:', error);
                            }

                            setPresentUrls(prevUrls => [...prevUrls, ...newUrls]);
                            seturlandfile({
                                url: String(response.data.data).split("?")[0]
                            })
                        })
                        .catch((error) => {
                            console.error('Error uploading files:', error);
                        });

                    // const fetchUploadFiles = async () => {
                    //     await Promise.all(state.signaturepad.PresentFullURL.map(async (item) => {
                    //         try {
                    //             const response = await fetch(item.url, {
                    //                 method: 'PUT',
                    //                 headers: {
                    //                     'Content-Type': item.type,
                    //                     "x-amz-acl": "public-read"
                    //                 },
                    //                 body: item.putfiles,
                    //             });
                    //         } catch (error) {
                    //             console.error('Error uploading files:', error);
                    //         }
                    //     }));
                    // }


                    // const fetchUploadUserImage = async () => {
                    //     await Promise.all(PresentUrls.map(async (item) => {
                    //         try {
                    //             const response = await fetch(item.url, {
                    //                 method: 'PUT',
                    //                 headers: {
                    //                     'Content-Type': item.type,
                    //                     "x-amz-acl": "public-read"
                    //                 },
                    //                 body: item.putfiles,
                    //             });
                    //             setFileTrue(false);

                    //             const data = await response.json();

                    //             console.log('Files uploaded successfully:', data);
                    //         } catch (error) {
                    //             console.error('Error uploading files:', error);
                    //         }
                    //     }));
                    // }

                    // form_data.append("data", JSON.stringify({}));
                    // if (FileTrue) {
                    //     form_data.append("user_image", FILE);
                    // }

                    // if (FileTrue) {
                    //     fetchUploadUserImage()

                    // }


                    // if (a == 0) {

                    // const payload = {
                    //     form_data: {
                    //         // sign: state.signaturepad.PresentURL,
                    //         user_image: presenturlInUrl.url
                    //     },
                    //     id: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
                    //         .id,
                    // };
                    // dispatch(setTheEMployeeAttendanceupdateProfileActions(payload));
                    // }


                }


                var file = croppedFile;
                var reader = new FileReader();

                reader.onloadend = function () {
                    setimg(reader.result)
                };
                reader.readAsDataURL(file);
                resolve(croppedFile);
            }, "image/jpeg");
        });
    }


    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const validateEmail = (email) => {
        return emailRegex.test(email);
    };

    const HandleClick = (e) => {
        var a = 0;

        const fetchUploadFiles = async () => {
            await Promise.all(state.signaturepad.PresentFullURL.map(async (item) => {
                try {
                    const response = await fetch(item.url, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': item.type,
                            "x-amz-acl": "public-read"
                        },
                        body: item.putfiles,
                    });
                } catch (error) {
                    console.error('Error uploading files:', error);
                }
            }));
        }


        const fetchUploadUserImage = async () => {
            await Promise.all(PresentUrls.map(async (item) => {
                try {
                    const response = await fetch(item.url, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': item.type,
                            "x-amz-acl": "public-read"
                        },
                        body: item.putfiles,
                    });
                    setFileTrue(false);

                    const data = await response.json();

                    console.log('Files uploaded successfully:', data);
                } catch (error) {
                    console.error('Error uploading files:', error);
                }
            }));
        }

        form_data.append("data", JSON.stringify({}));
        if (FileTrue) {
            form_data.append("user_image", FILE);
        }

        if (FileTrue) {
            fetchUploadUserImage()

        }
        console.log(FileTrue, "FileTrue");


        // if (a == 0 && state.signaturepad.PresentUrlsSended == true) {
        //     fetchUploadFiles();

        // }

        if (a == 0) {

            const payload = {
                form_data: {
                    // sign: state.signaturepad.PresentURL,
                    user_image: presenturlInUrl.url
                },
                id: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
                    .id,
            };
            dispatch(setTheudsEmployeeImage(presenturlInUrl.url));

            dispatch(setTheEMployeeAttendanceupdateProfileActions(payload));
        }
    };



    function dataURLtoFile(dataurl, filename) {
        // Decode the data URL
        var arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    }

    const capitalizeFirstLetter = (Letter) => {
        return Letter.charAt(0).toUpperCase() + Letter.slice(1);
    };


    return (
        <>
            <div
                className={stateDisplay ? "outterContent" : "inner-Content"}
                style={{ padding: "20px" }}
            >
                {/* <div className="card profile-card">
                    <div className="card-header  text-black HeaderOF UserProfileDatas">
                        <p className="UserDetails">Profile</p>
                        <div className="d-flex align-items-center containerParts">
                            <div className="InnerProfileImg">
                                <div
                                    className="Image"
                                    style={{
                                        width: "200px",
                                        height: "200px",
                                        border: "1px solid #ddd",
                                        borderRadius: "50%",
                                    }}
                                >
                                    {img ? (
                                        <img
                                            src={img}
                                            alt="Profile"
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                borderRadius: "50%",
                                            }}
                                            onClick={(e) => {
                                                window.open(img)
                                            }}
                                        />
                                    ) : (
                                        <img
                                            src={profile2}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                borderRadius: "50%",
                                            }}
                                        />
                                    )}
                                </div>
                                <div>
                                    <button
                                        className="Signatures CamBtn"
                                        onClick={handleCameraClick}
                                        style={{
                                            marginTop: "20px",
                                            background: "#ef4d39",
                                            marginRight: "10px",
                                            color: "#ffff !important",
                                            // background: "none",
                                        }}
                                    >
                                        Camera
                                    </button>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={handleFileUpload}
                                        style={{ display: "none" }}
                                        id="file-upload"
                                        ref={fileInputRef}
                                    />
                                    <label
                                        htmlFor="file-upload"
                                        className="Signatures CamBtn"
                                        style={{
                                            marginTop: "20px",
                                            background: "#ef4d39",
                                            color: "#ffff !important",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Upload
                                    </label>

                                </div>
                            </div>

                            <div className="RightSideField">
                                <p
                                    // className="NameField"
                                    className="ProfileNames"
                                    style={{ width: "100%", marginBottom: "0px" }}
                                >
                                    <span>Name:</span>
                                    {data.first_name}
                                </p>
                                <p
                                    className="ProfileNames"
                                    style={{ width: "100%", marginBottom: "0px" }}
                                >
                                    <span>Designation:</span>
                                    <span> {`  ${capitalizeFirstLetter(Roles)}`}</span>
                                </p>

                                <p className="ProfileNames" style={{ width: "100%" }}>
                                    <span>Email:</span>
                                    <span> {`  ${data.email}`}</span>
                                </p>



                                {data.phone_number != "" ? (
                                    <p className="mb-0 ProfileNames" style={{ width: "100%" }}>
                                        <span>Phone Number:</span>
                                        <span> {`  ${data.phone_number}`}</span>
                                    </p>
                                ) : null}
                            </div>
                        </div>
                    </div>
                    {FileTrue || signed ? (
                        <div
                            className="card-body CardBodySignature"

                        >
                            <div className=" row" style={{ width: "100%" }}>
                                <div
                                    className="col-12"
                                    style={{ display: "flex", justifyContent: "flex-end" }}
                                >
                                    <button
                                        class="btn  ButtonCSS"
                                        type="submit"
                                        onClick={(e) => {
                                            HandleClick(e);
                                        }}
                                        style={{ background: "#F15D39" }}
                                    >
                                        Update
                                    </button>
                                </div>
                            </div>
                        </div>
                    ) : null}
                </div> */}
                <div className="card profile-card">
                    <div className="card-header  text-black HeaderOF UserProfileDatas" style={{ height: "288px" }}>
                        {/* <p className="UserDetails">Profile</p> */}
                        <div className="d-flex align-items-center  containerParts containerPartsBox">
                            <div className="InnerProfileImg">
                                <div
                                    className="Image UDSEmpProfileImg"
                                    style={{
                                        // width: "200px",
                                        height: "200px",
                                        // border: "1px solid #ddd",
                                        borderRadius: "50%",

                                    }}
                                >
                                    {img != null && img != "" && img != undefined && profilePopup == false ? (
                                        <>

                                            <div className="ProffileImgsUpdatedEmp">
                                                <EditIcon className="ImageUploadsIcon"
                                                    onClick={(e) => {
                                                        // window.open(img)
                                                        setProfilePoup(true)
                                                    }}
                                                />

                                                <img
                                                    src={img}
                                                    alt="Profile"
                                                    style={{
                                                        width: "250px",
                                                        height: "250px",
                                                        borderRadius: "50%",
                                                        position: "absolute",
                                                        marginTop: "40px"
                                                    }}
                                                    onClick={(e) => {
                                                        // window.open(img)
                                                        setProfilePoup(true)
                                                    }}
                                                    className="Alteringimg"
                                                />


                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            {profilePopup == false && (

                                                <div className="ProffileImgsUpdatedEmp">
                                                    <EditIcon className="ImageUploadsIcon" style={{ position: "absolute" }}
                                                        onClick={(e) => {
                                                            // window.open(img)
                                                            setProfilePoup(true)
                                                        }}
                                                    />
                                                    <span className="EmployeeProfileImages"
                                                        onClick={(e) => {
                                                            setProfilePoup(true)
                                                        }}

                                                    ><span>{firstLetter}</span>

                                                    </span>
                                                </div>
                                            )}
                                        </>

                                    )


                                    }
                                    {
                                        profilePopup == true ?
                                            <div className="ProffileImgsUpdatedEmp">
                                                <span className="EmployeeProfileImages"
                                                // onClick={(e) => {
                                                //     setProfilePoup(true)
                                                // }}

                                                ><span>{firstLetter}</span>

                                                </span>
                                                <CameraAltIcon className="ImageUploadsIcon" style={{ position: "absolute" }} />
                                            </div>

                                            : null

                                    }

                                </div>
                                {/* <div>
                                    <button
                                        className="Signatures CamBtn"
                                        onClick={handleCameraClick}
                                        style={{
                                            marginTop: "20px",
                                            background: "#ef4d39",
                                            marginRight: "10px",
                                            color: "#ffff !important",
                                            // background: "none",
                                        }}
                                    >
                                        Camera
                                    </button>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={handleFileUpload}
                                        style={{ display: "none" }}
                                        id="file-upload"
                                        ref={fileInputRef}
                                    />
                                    <label
                                        htmlFor="file-upload"
                                        className="Signatures CamBtn"
                                        style={{
                                            marginTop: "20px",
                                            background: "#ef4d39",
                                            color: "#ffff !important",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Upload
                                    </label>

                                </div> */}
                            </div>

                            <div className="RightSideField RightSideFieldEmpUDS">
                                <p
                                    // className="NameField"
                                    className="ProfileNames"
                                    style={{ width: "100%", marginBottom: "0px" }}
                                >
                                    <span>Name </span>
                                    <span>                                   :  {data.first_name != "" && data.first_name != undefined &&
                                        data.first_name != null ? capitalizeFirstLetter(data.first_name.toLowerCase()) : ""}</span>
                                </p>
                                <p
                                    className="ProfileNames"
                                    style={{ width: "100%", marginBottom: "0px" }}
                                >
                                    <span>Designation </span>
                                    <span> {`:   ${capitalizeFirstLetter(Roles.toLowerCase())}`}</span>
                                </p>

                                <p className="ProfileNames" style={{ width: "100%" }}>
                                    <span>Email:</span>
                                    <span> {`:   ${data.email}`}</span>
                                </p>



                                {data.phone_number != "" ? (
                                    <p className="mb-0 ProfileNames" style={{ width: "100%" }}>
                                        <span>Phone Number:</span>
                                        <span> {`:  ${data.phone_number}`}</span>
                                    </p>
                                ) : null}
                            </div>

                        </div>
                    </div>
                    {/* {FileTrue || signed ? (
                        <div
                            className="card-body CardBodySignature"

                        >
                            <div className=" row" style={{ width: "100%" }}>
                                <div
                                    className="col-12"
                                    style={{ display: "flex", justifyContent: "flex-end" }}
                                >
                                    <button
                                        class="btn  ButtonCSS"
                                        type="submit"
                                        onClick={(e) => {
                                            HandleClick(e);
                                        }}
                                        style={{ background: "#F15D39" }}
                                    >
                                        Update
                                    </button>
                                </div>
                            </div>
                        </div>
                    ) : null} */}
                </div >
            </div >

            {isModalOpen === true ?
                <div className="RoleCreatePopup RoleCreatePopupTakeIms ">
                    <div className="BeforePopUp">
                        <div className="RolePopups  User_ProfileImage User_ProfileImageEmpcam"
                            // isOpen={isModalOpen}
                            onRequestClose={closeModal}
                            contentLabel="Capture Photo"
                            style={{
                                content: {
                                    top: "50%",
                                    left: "50%",
                                    right: "auto",
                                    bottom: "auto",
                                    marginRight: "-50%",
                                    transform: "translate(-50%, -50%)",
                                },
                            }}
                        >

                            <div className="Modal-header HeaderDesigns">
                                <div className="CloseIcon" onClick={() => {
                                    setProfilePoupuploadsnumber(2);
                                    // setProfilePoupuploads(false);
                                    // closeModal()
                                    setIsModalOpen(false);


                                }}>

                                    <ArrowBackIcon />

                                </div>
                                <h4>{"Camera"}</h4>

                            </div>

                            <Webcam
                                audio={false}
                                ref={webcamRef}
                                screenshotFormat="image/jpeg"
                                width="100%"
                                height="100%"
                                onUserMediaError={(error) => {
                                    alert("No camera detected or access denied. Please ensure a camera is connected.");
                                    console.error("Camera error:", error);
                                    setIsModalOpen(false)
                                }}

                            />
                            <div className="UserButton">

                                <button
                                    className="Signatures ButtonCSS"
                                    onClick={() => {
                                        setProfilePoupuploadsnumber(2);
                                        setIsModalOpen(false);
                                    }}
                                    style={{
                                        marginTop: "20px",
                                        marginRight: "10px",
                                        background: "#aaa",
                                        color: "#ffff !important",
                                    }}
                                >
                                    Close
                                </button>
                                <button
                                    className="Signatures ButtonCSS"
                                    onClick={capturePhoto}
                                    style={{
                                        marginTop: "20px",
                                        background: "#ef4d39",
                                        color: "#ffff !important",
                                    }}
                                >
                                    Capture Photo
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                : null}


            {profilePopup === true ?
                <div className="RoleCreatePopup  RoleCreatePopupEmprofileimg ">
                    <div className="BeforePopUp">
                        <div className="RolePopups  User_ProfileImageUDS"
                            onRequestClose={() => setProfilePoup(false)}
                            contentLabel="Capture Photo"
                            style={{
                                content: {
                                    top: "50%",
                                    left: "50%",
                                    right: "auto",
                                    bottom: "auto",
                                    marginRight: "-50%",
                                    transform: "translate(-50%, -50%)",
                                },
                            }}
                        >

                            <div className="UserButtonImgs" style={{ margin: "7px" }}>
                                <div className="Modal-header HeaderDesigns">
                                    <div className="CloseIcon" onClick={() => {
                                        if (profilePopupUploads == false) {
                                            setProfilePoup(false)
                                        }
                                        else {
                                            setProfilePoupuploads(false);
                                            setProfilePoupuploadsnumber(1)
                                        }
                                    }}>
                                        {profilePopupUploads == false ?
                                            <CloseOutlinedIcon />
                                            :
                                            <ArrowBackIcon />

                                        }
                                    </div>
                                    <h4>{profilePopupUploads == false && profilePopupUploadsNumber == 1 ? "Uds Account" : "Add profile picture"}</h4>

                                </div>
                                <div className="ProfileHeaders">

                                    {profilePopupUploads == false && profilePopupUploadsNumber == 1 && (
                                        <>
                                            <h5>Profile picture</h5>
                                            <p>A picture helps others recognize you and enables a seamless attendance experience. Use it to verify your punch-in and punch-out times accurately. Upload your image to get started.</p>
                                        </>
                                    )}</div>

                                <div className="ProffileImgsUpdatedEmpUpdates">
                                    <div>
                                        {img != "" && img != undefined && img != null ?
                                            <img
                                                src={img}
                                                alt="Profile"
                                                style={{
                                                    width: "200px",
                                                    height: "200px",
                                                    borderRadius: "50%",
                                                }}
                                                onClick={() => {
                                                    setProfilePoupuploads(true);
                                                    setProfilePoupuploadsnumber(2);
                                                }
                                                }
                                            />
                                            :
                                            (
                                                profilePopupUploads == false && profilePopupUploadsNumber == 1 && (


                                                    <span className="EmployeeProfileImages"
                                                        style={{
                                                            width: "200px",
                                                            height: "200px",
                                                            borderRadius: "50%",
                                                        }}
                                                        onClick={() => setProfilePoupuploads(true)}
                                                    ><span>{firstLetter}</span>

                                                    </span>
                                                ))
                                        }
                                    </div>
                                </div>
                                {profilePopupUploads == true && profilePopupUploadsNumber == 2 && (
                                    <div className="UploadedEmpProfiles">
                                        {/* <div >
                                           <p>Drag photo here</p>
                                            <p>— or —</p>
                                        </div> */}
                                        <div className="TwooptionsApply">
                                            <input
                                                type="file"
                                                accept="image/*"
                                                onChange={handleFileUpload}
                                                style={{ display: "none" }}
                                                id="file-upload"
                                                ref={fileInputRef}
                                            />
                                            <label
                                                htmlFor="file-upload"
                                                className="Signatures CamBtn AddProfilebtnim"
                                                style={{
                                                    marginTop: "20px",
                                                    background: "#ef4d39",
                                                    color: "#ffff !important",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                <LaptopIcon className="DesignImgs" />
                                                Upload from computer
                                            </label>

                                            <button
                                                className="Signatures AddProfilebtnim CamBtn"
                                                onClick={handleCameraClick}
                                                style={{
                                                    marginTop: "20px",
                                                    background: "#ef4d39",
                                                    marginRight: "10px",
                                                    color: "#ffff !important",
                                                }}
                                            >
                                                <AddAPhotoIcon className="DesignImgs" />
                                                Take a picture
                                            </button>
                                        </div>

                                    </div>
                                )}
                                {
                                    profilePopupUploads == false && profilePopupUploadsNumber == 1 ?
                                        <button className="AddProfileImgs  AddProfilebtn ButtonCSS"
                                            onClick={() => {
                                                setProfilePoupuploads(true); setProfilePoupuploadsnumber(2);
                                            }}
                                        >
                                            <CameraAltIcon className="DesignImgs" />
                                            Add profile picture
                                        </button>
                                        : null}
                            </div>
                        </div>
                    </div>
                </div>
                : null}
            {
                CroppImageView && (
                    <ImageCropper
                        updateAvatar={updateAvatar}
                        selectedImage={UserFile}
                        getCroppedImg={getCroppedImg}
                        closeModal={() => setCroppImageView(false)}
                    />
                )
            }

        </>
    );
};

export default UdsEmpProfile;
